import { Container } from 'react-bootstrap';

const DatosDestino = ({ destino }) => {
    return (
        <div className="pt-2 pb-5 potblur">
            <h1 className="mb-5 text-center">{destino.elnombre}</h1>
            <Container>
                <div className="noticia-individual-descripcio-llarga">
                    <div dangerouslySetInnerHTML={{ __html: destino.eltexto }}></div>
                </div>
            </Container>
        </div>
    );
}

export default DatosDestino;
